module.exports = __webpack_public_path__ + "Server-CalamariNeedsUpgrade-TentacleActive.a2a9dd28fd437be2e97a5d856e09afeb.hashedasset.svg";